import PropTypes from 'prop-types';

import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Carousel from 'nuka-carousel';

import Icon from 'components/Icon/Icon';
import Thumbnail from 'components/Thumbnails/Thumbnail';
import { isEqual } from 'lodash';
import styles from './projectCarousel.module.scss';

class ProjectCarousel extends Component {
  static propTypes = {
    projects: PropTypes.array,
  };

  constructor(props) {
    super(props);
    this.state = {
      width: 0,
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 0);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !isEqual(this.props, nextProps) || !isEqual(this.state, nextState);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  updateDimensions = () => {
    this.setState({ width: window.innerWidth });
  };

  render() {
    const { projects, user } = this.props;
    const slidesToShow =
      window.innerWidth >= 1440
        ? 3.25
        : window.innerWidth >= 1024
        ? 2.5
        : window.innerWidth >= 768
        ? 2.75
        : 1.25;

    return (
      <div
        style={{
          borderRadius: '4px',
          background: '#eeeeee',
          padding: '8px',
        }}
      >
        <Carousel
          cellAlign="left"
          initialSlideHeight={180}
          slidesToShow={slidesToShow}
          dragging
          swiping
          renderCenterRightControls={({
            currentSlide,
            nextSlide,
            slidesToScroll,
            slideCount,
            wrapAround,
          }) => (
            <button
              type="button"
              style={{
                border: 0,
                background: '#eeeeee',
                color: '#312855',
                padding: 0,
                outline: 0,
                opacity:
                  currentSlide + slidesToScroll >= slideCount && !wrapAround
                    ? 0
                    : 1,
                cursor: 'pointer',
                marginRight: '-4px',
                fontSize: 30,
              }}
              onClick={nextSlide}
            >
              <Icon style={{ paddingLeft: '5px' }} icon="&#xe62b;" />
            </button>
          )}
          renderCenterLeftControls={({
            currentSlide,
            wrapAround,
            previousSlide,
          }) => (
            <button
              type="button"
              style={{
                border: 0,
                background: '#eeeeee',
                color: '#312855',
                padding: 0,
                outline: 0,
                opacity: currentSlide === 0 && !wrapAround ? 0 : 1,
                cursor: 'pointer',
                marginRight: '-4px',
                fontSize: 30,
              }}
              onClick={previousSlide}
            >
              <Icon style={{ paddingRight: '5px' }} icon="&#xe62a;" />
            </button>
          )}
          withoutControls={projects.length < 3}
          id={`${user.display_name} carousel`}
        >
          {projects.map((project) => {
            if (/image|video|other/.test(project?.mediaType)) {
              return (
                <div
                  className={styles.carouselSlide}
                  key={`project-carousel-linkdiv-${project.id}`}
                >
                  <Link
                    className="no-decoration"
                    to={user.links.main_relative}
                    title={user.displayname}
                    key={`project-carousel-link-${project.id}`}
                    target="_blank"
                  >
                    <Thumbnail
                      key={`project-carousel-thumbnail-${project.id}`}
                      aspectRatio="16:9"
                      thumbnails={project.thumbnails}
                      style={{ width: '100%', height: '100%' }}
                    />
                  </Link>
                </div>
              );
            }
          })}
        </Carousel>
      </div>
    );
  }
}

export default ProjectCarousel;
